export const cards = [
    {
        "img": "https://res.cloudinary.com/nocturnalmusing/image/upload/v1600114905/Portfolio/PixelMenagerie_fhha8r.png",
        "alt": "Pixel Menagerie Homepage",
        "name": "Pixel Menagerie",
        "caption": "This full-stack application I had the pleasure of developing allows users to create a profile and collect a selection of virtual pets. Users are able to edit a pet's name, personality, and release them in the event they are no longer wanted.",
        "url": "http://pixel-menagerie.surge.sh/"
    },

    {
        "img": "https://res.cloudinary.com/nocturnalmusing/image/upload/v1600114905/Portfolio/CloserLook_kvxmxf.png",
        "alt": "Closer Look Homepage",
        "name": "Closer Look",
        "caption": "I collaborated with a team of developers and UX Designers to develop Closer Look; a website which allows users to dive deeper into a brands' ethical actions when viewing their products while shopping online.",
        "url": "https://relaxed-brown-89d408.netlify.app/"
    },

    {
        "img": "https://res.cloudinary.com/nocturnalmusing/image/upload/v1600114905/Portfolio/PokemonRandom_oxir7m.png",
        "alt": "Pokemon Random Generator",
        "name": "Pokemon Team Generator",
        "caption": "Utilizing the PokemonAPI I developed a sorting game which allows users to generate their own team of six Pokemon, delivering important information in regards to each creature for the user to review.",
        "url": "https://git.generalassemb.ly/Calliope/POKEMON-Random-Team-Generator"
        // This URL leads to the repo for this project. Update when you've reworked the code and properly deployed it.
    },
    
    {
        "img": "https://res.cloudinary.com/nocturnalmusing/image/upload/v1600114905/Portfolio/ComfortKitten_amu5hj.png",
        "alt": "Comfort Kitten Homepage",
        "name": "Comfort Kitten",
        "caption": "Comfort Kitten is my first venture into developing a full-stack mental health app, with a focus on mitigating symptoms of mental illness and connecting individuals with local resources.",
        "url": "https://comfortkitten.netlify.app/"
    },
]